import PropTypes from "prop-types";
import _ from "lodash";
import { Box, Divider } from "@mui/material";
import useFetch from "../../utils/useFetch";
import FormControl from "../FormControl";
import FormControlWithSubFields from "../FormControlWithSubFields";
import "../../styles/QuestionnaireContent.css";
import { useState, useEffect } from "react";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import ErrorAlert from "../../toolkit/ErrorAlert";
import BaseURL from "../../utils/base-uri.json";
import { SettingsBackupRestore } from "@mui/icons-material";
import * as math from "mathjs";
import fileDownload from "js-file-download";
import axios from "../../utils/fvAxios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SectionNote from "./SectionNote";

function getInputType(type) {
  switch (type) {
    case "CtrlRadio":
      return "radio";
    case "CtrlCheckBox":
      return "checkbox";
    case "CtrlSelect":
    case "CtrlSelectMultiple":
      return "select";
    case "CtrlTextArea":
      return "textarea";
    case "CtrlTextNumber":
      return "number"; //TODO: Need to changes this from text to number and need to fix the binding issue.
    //field is changed to number and its working for number input need to check binding issue
    case "CtrlTextEmail":
      return "email";
    case "CtrlTextMobile":
      return "tel";
    case "CtrlTextPassword":
      return "password";
    case "CtrlTextDate":
      return "date";
    case "CtrlLabel":
      return "label";
    case "CtrlText":
      return "text";
    case "CtrlButton":
      return "button";
    default:
      return "none";
  }
}
// const params = new URLSearchParams(window.location.search);
// const PQID = params.get("pqid");

function getFieldOptions(str = "") {
  if (!str) {
    str = "";
  }
  {
    return str
      ?.split("|")
      ?.filter((i) => i?.trim())
      ?.map((i) => ({ id: i, text: i }));
  }
}

function getDefaultUserResponse(field) {
  if (field?.type === "CtrlTextDate") {
    return getFormattedDate(field?.answer);
  } else if (field?.type == "CtrlLabel") {
    return field?.options;
  } else if (field?.type === "CtrlSelectMultiple") {
    return field?.answer?.split("|");
  } else if (field?.type === "CtrlCheckBox") {   // radio buttons answers convert to Check box answers
    return (field?.answer) == "Yes" ? "true" : ((field?.answer) == "Yes" ? "false" : ((field?.answer) == "Not Applicable" ? "false" : field?.answer));
  } else if (field?.type === "CtrlRadio") {   // Check box answers convert to radio buttons answers
    return (field?.answer).toLowerCase() == "true" ? "Yes" : ((field?.answer).toLowerCase() === "false" ? "No" : (field?.answer == "True" ? "true" : (field?.answer === "False" ? "false" : field?.answer)));
  } else {
    return field?.answer;
  }
}
function getFormattedDate(date) {
  const parts = date?.split("/");
  if (parts?.length === 3) {
    const [month, day, year] = parts;
    return `${year}-${month?.padStart(2, "0")}-${day?.padStart(2, "0")}`;
  }
  return date;
}


function getFiledPositioning(alignment) {
  return `${alignment}` === "0" ? "horizontal" : "vertical";
}


function fieldsAdaptor({ subSectionQuestions = [], NotMandatory }) {
  const userResponse = {};
  const userResponseDependencies = {};
  const orignalQuestions = _.cloneDeep(subSectionQuestions);
  subSectionQuestions = subSectionQuestions?.map((field) => {
    const newField = {
      id: `${field.questionId}`,
      text: field.questionText,
      required: field.isMandatory,
      heighlight: field.hasHighlights + "",
      color: field.questionColor,
      inputType: getInputType(field.inputType),
      qFormula: field.qFormula,
      isBold: field?.isBold
    };
    const subFields = field?.questionColumns || [];
    if (subFields?.length === 1) {
      const sf = subFields[0];
      Object.assign(newField, {
        name: `${sf?.columnId}`,
        inputType: getInputType(sf?.type),
        multiple: sf?.type === "CtrlSelectMultiple",
        options: getFieldOptions(sf?.options),
        userResponse: getDefaultUserResponse(sf),
        fieldPositioning: getFiledPositioning(sf?.alignment),
        preQualRecId: sf?.preQualRecId,
        qFormula: sf?.qFormula,
        Reference: sf?.qTableReference,
        TableRefFieldValueDisplay:
          sf.qTableReference?.qcTableRefFieldValueDisplay,
        TableReference: sf.qTableReference?.qcTableReference,
        TableReferenceField: sf.qTableReference?.qcTableReferenceField,
        ButtonTypeReferenceValue: sf.buttonTypeReferenceValue,
        required: field.isMandatory,
        isBold: field?.isBold
      });

      // if (field.ParentQColumnId) {
      //   Object.assign(newField, {
      //     dependentOn: field.ParentQColumnId,
      //     enableIfParentValue: field.questionValue || true,
      //   });
      // }
    } else if (subFields?.length > 1) {
      newField.subFields = subFields?.map((sf) => {
        return {
          id: sf?.columnId,
          name: sf?.columnId,
          questionId: field?.questionId,
          inputType: getInputType(sf?.type),
          multiple: sf?.type === "CtrlSelectMultiple",
          options: getFieldOptions(!sf?.ColumnOptions ? sf?.options : sf?.ColumnOptions),
          userResponse: getDefaultUserResponse(sf),
          qFormula: sf?.qFormula,
          required: field?.isMandatory,
        };
      });
      newField.fieldPositioning = getFiledPositioning(subFields[0]?.alignment);
    }
    if (field?.dependOn && field?.dependOn?.length > 0) {

      const combinedDependOn = [];

      field?.dependOn?.forEach(item => {
        const existingItem = combinedDependOn?.find(combinedItem =>
          combinedItem.questionId === item.questionId &&
          combinedItem.subSectionId === item.subSectionId &&
          combinedItem.dependentType === item.dependentType
        );

        if (existingItem) {
          existingItem.questionValue += `,${item.questionValue}`;
        } else {
          combinedDependOn?.push({ ...item });
        }
      });



      combinedDependOn?.forEach((item) => {
        var parent = item;
        if (orignalQuestions?.some(x => x.questionId === parent?.questionId)) {

          Object.assign(newField, {
            dependentOn: parent?.questionId,
            dependentValue: parent?.questionValue,
            enableIfParentValue: parent?.enableIfParentValue || true,
            color: orignalQuestions?.find(x => x.questionId == parent?.questionId)?.questionColor,
            heighlight: orignalQuestions?.find(x => x.questionId == parent?.questionId)?.hasHighlights + ""
          });
        }
      });
    }
    return newField
  });
  subSectionQuestions?.forEach((field, idx, fields) => {
    if (field?.subFields) {
      field?.subFields?.forEach((sf) => {
        _.set(userResponse, [field?.id, sf?.id], sf?.userResponse || "");
      });
    } else {
      _.set(userResponse, [field?.id], field?.userResponse || "");
    }
    if (field?.dependentOn) {
      const parent = fields?.find((f) => f.id == field.dependentOn);

      // if (parent) {
      //   // field.hidden = parent.userResponse == "" ? false : true !== field.dependentValue;    //if parent questions answer is empty return false

      //   field.hidden = field.dependentValue.indexOf(parent.userResponse) == -1 || parent.userResponse == "";   // For children that have multiple parents in dependent questions 
      //   _.set(userResponseDependencies, [field.id], {
      //     parent: parent.id,
      //     enableIfParentValue: field.enableIfParentValue,
      //   });
      // }

      if (parent) {
        const parentResponse = parent?.userResponse;
        const dependentValues = field?.dependentValue?.split(",") || [];

        if (Array.isArray(parentResponse)) {
          // Handle cases where parentResponse is an array (e.g., multi-select, checkboxes)
          field.hidden = !parentResponse?.some(val => dependentValues?.includes(val));
        } else {
          // Handle single value responses
          field.hidden = !dependentValues?.includes(parentResponse) || parentResponse == "";
        }

        _.set(userResponseDependencies, [field?.id], {
          parent: parent?.id,
          enableIfParentValue: field?.enableIfParentValue,
        });
      }
    }
  });
  return { subSectionQuestions, userResponse, userResponseDependencies };
}

function formDataAdaptor(oldData, userResponse) {
  const data = _.cloneDeep(oldData);
  for (let idx = 0; idx < userResponse?.length; idx++) {
    Object.keys(userResponse[idx])?.forEach((fieldId) => {
      const newFieldData = userResponse[idx][fieldId];
      if (newFieldData === undefined) return;
      const oldFieldData = data?.data?.subSectionDetails[
        idx
      ]?.subSectionQuestions?.find((f) => `${f.questionId}` === `${fieldId}`); //TODO : Add data.subSectionQuestions replace with fields
      //  console.log(oldFieldData);
      if (!oldFieldData) return;
      const oldSubFields = oldFieldData?.questionColumns || [];
      if (oldSubFields?.length === 1) {
        oldSubFields[0].answer = _.isArray(newFieldData)
          ? newFieldData?.join("|")
          : newFieldData;
      } else if (oldSubFields?.length > 1) {
        oldSubFields?.forEach((sf) => {
          if (sf?.columnId in newFieldData)
            sf.answer = newFieldData[sf?.columnId];
        });
      }
    });
  }

  return data;
}

export default function QuestionnaireContext({
  dataUrl,
  setShowFormButtons,
  setModifiedData,
  reset,
  resetButtons,
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  hasUnsavedChanges,
  IsSubSectionCompleted,
  SAVE,
  Validate,
  RemoveRequiredHiddenFields,
  Required,
  SubSectionName,
  Triger,
  VIEWMODE,
  RESETQUESTIONS,
  updateSubSectionVisibility,
  validateAllSubSectionQuestions,
  languageId,
  PQCLIENTID,
  NotMandatory,
  ResetInformation,
  PqUserRequest,
  setPqUserRequest,
  Editaccess,
  setSaveButtionHiden,
  setWithoutmodifiedData,
  Information,
  ClearFields,
  ClearAllFormFields

}) {
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");
  const [Refresh, setRefresh] = useState(true);
  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    BaseURL.baseUrl +
    "Prequalification/SectionOrSubSectionDetails?pqId=" +
    PQID +
    "&sectionId=" +
    Secid +
    "&subSectionTypeCondition=" +
    SubSectionTypeCondition +
    "&sectionType=" +
    SectionType +
    "&subSectionId=" +
    SubId +
    "&Refresh=" +
    Refresh
  ); // TODO: remove localhost arg
  const [userResponse, setUserResponse] = useState([]);
  const [userResponseDependencies, setUserResponseDependencies] = useState([]);
  const [subSectionQuestions, setFields] = useState([]);
  const [SubsectionNote, setSubsectionNote] = useState("");
  const [subSectionResp, setSubSectionResp] = useState();
  const [unhiddenFields, setUnhiddenFields] = useState(
    //subSectionQuestions.filter((f) => !f.hidden)
    []
  );

  const [ResetSubsections, setResetSubsections] = useState([]);


  const [ResetData, setResetData] = useState([]);
  useEffect(() => {
    setSaveButtionHiden(true);
    if (resp?.data?.subSectionDetails) {
      resp?.data?.subSectionDetails?.forEach((subSection) => {
        subSection?.subSectionQuestions?.forEach((question) => {
          question?.questionColumns?.forEach((column) => {
            if (column?.type === "CtrlCheckBox" && column?.answer === "") {
              column.answer = "false";
            }
          });
        });
      });
      Information(resp?.data);
      setSubSectionResp(resp?.data);

      var userResponseList = [];
      var userResponseDependenciesList = [];
      var subSectionQuestionsList = [];
      for (let i = 0; i < resp?.data?.subSectionDetails?.length; i++) {
        Editaccess(resp?.data?.subSectionDetails[i]?.editAccess);
        setSubsectionNote(resp?.data?.subSectionDetails[i]?.subsectionNote);
        setWithoutmodifiedData(resp?.data);
        if (resp?.data?.subSectionDetails[i]?.subSectionQuestions) {
          const {
            subSectionQuestions,
            userResponse,
            userResponseDependencies,
          } = fieldsAdaptor(resp?.data?.subSectionDetails[i]);
          userResponseList?.push(userResponse);
          subSectionQuestionsList?.push(subSectionQuestions);

          if (userResponseDependencies && Object.keys(userResponseDependencies)?.length > 0)
            userResponseDependenciesList?.push(userResponseDependencies);
        }
        // No Mandatory Questions in a Subsection 
        const mata = resp?.data?.subSectionDetails?.map((f) => f.subSectionQuestions?.find((r) => (r?.isMandatory)))
        const hasObject = mata?.some(item => typeof item === 'object' && item !== null);
        const NoMandatoryQuestion = resp?.data?.subSectionDetails[i]?.subSectionQuestions?.find((f) => f?.isMandatory) ? true : false || hasObject
        NotMandatory(NoMandatoryQuestion);

        // const result = resp?.data?.subSectionDetails[i].subSectionQuestions.filter(item => item.isMandatory).map(item => ({
        //   isMandatory: item.isMandatory,
        //   answer: item.questionColumns[0].answer
        // }));
        // console.log(result);

      }
      setUnhiddenFields([]);
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
      validateAllSubSectionQuestions(subSectionQuestionsList);

      setSaveButtionHiden(false);
    }
  }, [resp]);

  useEffect(() => {
    if (PqUserRequest == true) {
      setRefresh(!Refresh);
      setModifiedData({});
      setPqUserRequest(false);
    }
  }, [PqUserRequest]);

  const hideSubSectionsConditionally = (fieldId, answer) => {
    const subSectionToHide = [];
    const subSectionToShow = [];
    resp?.data?.subSectionDetails?.flatMap((details) => {
      details?.subSectionQuestions?.forEach((question, idx) => {

        // if (question.childSubSections.length > 0 && question.questionId == fieldId) {
        //   if (question.childSubSections[0].questionValue !== answer) {
        //     subSectionToHide.push(question.childSubSections[0].subSectionId);
        //   } else {
        //     subSectionToShow.push(question.childSubSections[0].subSectionId);
        //   }
        //   return question;
        // }

        if (question?.questionId == fieldId) {
          for (let i = 0; i < question?.childSubSections?.length; i++) {
            if (question?.childSubSections[i]?.questionValue !== answer) {
              subSectionToHide?.push(question?.childSubSections[i]?.subSectionId);
            } else {
              subSectionToShow?.push(question?.childSubSections[i]?.subSectionId);
            }
          }
          return question;
        }
        return question;
      });
    });
    ResetSubsections?.push(...subSectionToShow);
    updateSubSectionVisibility(subSectionToHide, subSectionToShow);
  };


  useEffect(() => {
    if (subSectionQuestions) {
      var unhiddenFieldsList = [];
      for (let i = 0; i < subSectionQuestions?.length; i++) {
        unhiddenFieldsList?.push(
          subSectionQuestions[i]?.filter((f) => !f.hidden)
        );
        setShowFormButtons(
          !!subSectionQuestions[i]?.filter((f) => f.inputType !== "label")?.length
        ); //todo: Revisit again
      }
      setUnhiddenFields(unhiddenFieldsList);
    }
  }, [subSectionQuestions]);


  useEffect(() => {
    if (reset) {
      const INFO = !ResetInformation ? resp?.data : (ResetInformation == "" ? ResetData?.data : ResetInformation?.data);//For Reset Form
      setSubSectionResp(INFO);

      var userResponseList = [];
      var subSectionQuestionsList = [];
      var userResponseDependenciesList = [];
      // var userResponseList = resp?.data?.subSectionDetails.map((r) => {
      //return fieldsAdaptor(r)
      for (let i = 0; i < INFO?.subSectionDetails?.length; i++) {
        if (INFO?.subSectionDetails[i]?.subSectionQuestions) {
          const {
            subSectionQuestions,
            userResponse,
            userResponseDependencies,
          } = fieldsAdaptor(INFO?.subSectionDetails[i]);

          userResponseList?.push(userResponse);
          subSectionQuestionsList?.push(subSectionQuestions);
          userResponseDependenciesList?.push(userResponseDependencies);
        }
      }
      // })
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
      setModifiedData({});
      validateAllSubSectionQuestions(subSectionQuestionsList);

      updateSubSectionVisibility(ResetSubsections, []);
      //const { userResponse } = fieldsAdaptor(resp?.data?.subSectionDetails[0]);
      //userResponseList.push(res);
      setResetSubsections([]); // Reset SubSections
    }
  }, [reset]);

  useEffect(() => {
    setModifiedData({}); //TODO:- Add new code  here!
  }, [resetButtons]);


  //Clear Form
  useEffect(() => {
    if (ClearFields) {
      const INFO = JSON.parse(JSON.stringify(resp?.data)); // Deep clone

      INFO?.subSectionDetails?.forEach(subSection => {
        subSection.subSectionQuestions?.forEach(question => {
          question.questionColumns?.forEach(column => {
            column.answer = ""; // Set answer to empty
          });
        });
      });
      setSubSectionResp(INFO);
      var userResponseList = [];
      var subSectionQuestionsList = [];
      var userResponseDependenciesList = [];
      for (let i = 0; i < INFO?.subSectionDetails?.length; i++) {
        if (INFO?.subSectionDetails[i]?.subSectionQuestions) {
          const {
            subSectionQuestions,
            userResponse,
            userResponseDependencies,
          } = fieldsAdaptor(INFO?.subSectionDetails[i]);

          userResponseList?.push(userResponse);
          subSectionQuestionsList?.push(subSectionQuestions);
          userResponseDependenciesList?.push(userResponseDependencies);
        }
      }
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
      setModifiedData({});
      validateAllSubSectionQuestions(subSectionQuestionsList);
      updateSubSectionVisibility(ResetSubsections, []);
      setResetSubsections([]); // Reset SubSections
      ClearAllFormFields("", INFO);
    }
  }, [ClearFields]);
  //

  function onResponseChange(fieldId, value, qColumnId) {
    const data = _.cloneDeep(userResponse);

    var qFormulaFields = subSectionQuestions
      ?.flat()
      ?.filter((r) => r.qFormula)
      ?.map((r) =>
        r?.qFormula
          ?.toString()
          ?.replace(/\+/g, " ")
          ?.replace(/-/g, " ")
          ?.replace(/\*/g, " ")
          ?.replace(/\//g, " ")
          ?.replace(/\(/g, " ")
          ?.replace(/\)/g, " ")
          ?.split(" ")
      )
      ?.flat()
      ?.filter((r) => r && r.startsWith("Q"));

    var QformulaSubFields = subSectionQuestions
      ?.flat()
      ?.filter((r) => r.subFields)
      ?.flatMap((r) => r.subFields)
      ?.filter((r) => r.qFormula)
      ?.map((r) =>
        r?.qFormula
          ?.toString()
          ?.replace(/\+/g, " ")
          ?.replace(/-/g, " ")
          ?.replace(/\*/g, " ")
          ?.replace(/\//g, " ")
          ?.replace(/\(/g, " ")
          ?.replace(/\)/g, " ")
          ?.split(" ")
      )
      ?.flat()
      ?.filter((r) => r && r.startsWith("Q"));

    if (!qFormulaFields) qFormulaFields = [];
    if (!QformulaSubFields) QformulaSubFields = [];
    //Array.propTypes.push.apply(qFormulaFields,QformulaSubFields);
    Array.prototype?.push?.apply(qFormulaFields, QformulaSubFields);
    var FormulaDependentQuestions = qFormulaFields?.filter(function (itm, i, a) {
      return i == a?.indexOf(itm);
    });

    for (let idx = 0; idx < subSectionQuestions?.length; idx++) {

      //Dependency Questions handling
      if (userResponseDependencies.length > 0) {
        for (const [key, value1] of Object.entries(userResponseDependencies[0])) {
          if (value1.parent !== fieldId) {
            //If the question is not dependent on any question
            continue;
          }
          const dependentField = subSectionQuestions[idx]?.find(
            (f) => f.id == key
          ); //get questions info based on key

          if (dependentField) {
            //dependentField.hidden = value != dependentField?.dependentValue;
            var valuesArray = dependentField?.dependentValue?.split(',');

            dependentField.hidden = !valuesArray?.includes(value);
            if (dependentField?.hidden) {
              RemoveRequiredHiddenFields(
                dependentField?.id,
                dependentField?.userResponse
              );
            } else {
              setValidate(
                dependentField?.id,
                data[0][dependentField?.id] == ""
                  ? dependentField?.userResponse
                  : data[0][dependentField?.id],
                dependentField?.required
              );
            }
            setFields([...subSectionQuestions]);
          }
        }
      }
      const question = subSectionQuestions[idx]?.find((f) => f.id == fieldId);
      if (question && question.id == fieldId) {
        if (question?.subFields) {
          data[idx][fieldId][qColumnId] = value[qColumnId];
          hideSubSectionsConditionally(fieldId, value[qColumnId]);
        } else {
          data[idx][fieldId] = value;
          hideSubSectionsConditionally(fieldId, value);
        }
      }

      if (FormulaDependentQuestions?.includes("Q" + qColumnId)) {
        const questionAndAnsFields = subSectionQuestions
          ?.flat()
          ?.filter((r) => FormulaDependentQuestions?.includes("Q" + r?.id))
          ?.map((r1) => ({ qId: "Q" + r1?.id, answer: data[idx][r1?.id] }));
        // .map((r1) => ({ qId: "Q" + r1.id, answer: r1.userResponse }));

        const questionAndAnsSubFields = subSectionQuestions
          ?.flat()
          ?.filter((r) => r.subFields)
          ?.flatMap((r) => r.subFields)
          ?.filter((x) => x.inputType == "text" || x.inputType == "number")
          ?.map((r) => ({
            qId: "Q" + r?.id,
            answer: Array.isArray(data[idx][r?.questionId]) ? data[idx][r?.questionId][r?.id] : data[idx][r?.questionId],
            questionId: r?.questionId,
          }));

        questionAndAnsFields?.push(...questionAndAnsSubFields);

        const allFormulaQuestions = subSectionQuestions?.flat()?.filter((r) => r?.qFormula);

        allFormulaQuestions?.push(
          ...subSectionQuestions
            ?.flat()
            ?.filter((r) => r?.subFields)
            ?.flatMap((r) => r?.subFields)
            ?.filter((r) => r?.qFormula)
        );

        const _dependedOn = [];
        _dependedOn?.push(
          ...getDependentQuestions(
            qColumnId,
            FormulaDependentQuestions,
            allFormulaQuestions
          )
        );

        EvaluateFormulaOfDependent(idx, _dependedOn, data, questionAndAnsFields);
      }
    }

    setUserResponse(data);
    setModifiedData(formDataAdaptor(resp, data));
    setResetData(formDataAdaptor(resp, data));   // Reset fields
  }

  const EvaluateFormulaOfDependent = (idx, _dependedOn, data, questionAndAnsFields) => {
    _dependedOn?.forEach((_dependedQuestion) => {
      var currentFormula = _dependedQuestion?.qFormula;
      var formulaFields = currentFormula
        ?.toString()
        ?.replace(/\+/g, " ")
        ?.replace(/-/g, " ")
        ?.replace(/\*/g, " ")
        ?.replace(/\//g, " ")
        ?.replace(/\(/g, " ")
        ?.replace(/\)/g, " ")
        ?.split(" ")
        ?.filter((r) => r.startsWith("Q"));

      // formulaFields.forEach((formulaField) => {
      //   var ans = questionAndAnsFields?.filter((r) => r.qId == formulaField);
      //   currentFormula = currentFormula?.replace(
      //     formulaField,
      //     ans[0]?.answer?.replace(/,/g, "")?.length == 0 ? "0" : ans[0]?.answer?.replace(/,/g, "")
      //   );
      // });

      formulaFields?.forEach((formulaField) => {
        const ans = questionAndAnsFields?.filter((r) => r.qId == formulaField);
        const answerValue = ans[0]?.answer?.replace(/,/g, "")?.length == 0 ? "0" : ans[0]?.answer?.replace(/,/g, "");

        // Check if answerValue is undefined and set it to "0"
        currentFormula = currentFormula?.replace(formulaField, answerValue || "0");
      });

      const answer = evaluateExpression(currentFormula);
      if (
        _.isArray(
          data[idx][_dependedQuestion?.questionId ?? _dependedQuestion?.id]
        )
      ) {
        // need to check this [_dependedQuestion.questionId ?? _dependedQuestion.id]
        data[idx][_dependedQuestion?.questionId][_dependedQuestion?.id] = answer;
        const dependedAnswerField = questionAndAnsFields?.find(
          (r) => r.qId === `Q${_dependedQuestion?.id}`
        );
        if (dependedAnswerField) {
          dependedAnswerField.answer = answer;
        }
      } else {
        data[idx][_dependedQuestion?.id] = answer + ""; // for Oops error {eval(currentFormula)}
        const dependedAnswerField = questionAndAnsFields?.find((r) => r?.qId === `Q${_dependedQuestion?.id}`)
        if (dependedAnswerField) dependedAnswerField.answer = answer;
      }
      //calculate other questions answer after above calculation
      if (_dependedQuestion?.subDependents) {
        EvaluateFormulaOfDependent(idx, _dependedQuestion?.subDependents, data, questionAndAnsFields);
      }
    });
  };

  // function evaluateExpression(expression) {
  //   const result = eval(expression);
  //   return !isNaN(result) && isFinite(result) ? result?.toString() : "0";
  // }
  function evaluateExpression(expression) {
    try {
      // Replace any leading zero in numbers (except "0" itself) with their decimal equivalent
      const sanitizedExpression = expression?.replace(/(\D|^)(0\d+)/g, (_, prefix, num) => `${prefix}${parseInt(num, 10)}`);
      const result = eval(sanitizedExpression);
      return !isNaN(result) && isFinite(result) ? result?.toFixed(2).toString() : "0";
    } catch (e) {
      console.error("Error evaluating expression:", e);
      return "0";
    }
  }

  const getDependentQuestions = (qColumnId, FormulaDependentQuestions, questions) => {
    const _dependedOn = [];
    questions?.forEach((question) => {
      if (question?.qFormula && question?.qFormula?.includes(`Q${qColumnId}`)) {
        const matches = question?.qFormula?.match(/Q(\d+)/);
        if (matches && matches.length > 1) {
          if (FormulaDependentQuestions?.includes("Q" + question?.id)) {
            _dependedOn?.push({
              ...question,
              subDependents: getDependentQuestions(question?.id, FormulaDependentQuestions, questions),
            });
          } else _dependedOn?.push(question);
          return;
        }
      }
    });
    return _dependedOn;
  };

  // const [validate, setValidate] = useState();
  // const setValidate = ({id, val, idx}) => { //0- Error 1-No error //Written by Rajesh
  //   Validate(val);
  // }

  const setValidate = (fieldId, r, isRequired, subSecField = 0) => {
    if (isRequired) {
      Validate(fieldId, r, subSecField);
    }
  };
  // const setRequired = (text) => {
  //   Required(text);
  // }

  const GetAgreement = () => {
    // axios.get("Prequalification/GenerateAgreementSectionPDF?TemplateSecID=" + Secid + "&PQId=" + PQID, {
    //   responseType: 'blob',
    // }).then((res) => {
    //   fileDownload(res?.data.data, "Pdf")
    // })

    axios
      .get(
        "Prequalification/GenerateAgreementSectionPDF?TemplateSecID=" +
        Secid +
        "&PQId=" +
        PQID,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        fileDownload(res.data, "PDF");
      });
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <Box className="questionnaire-content">
          <form>
            {unhiddenFields?.map((fields, idx) => (
              <div key={idx}>
                <div className="d-flex mx-2">
                  <b
                    className="bg-light w-100 px-3 py-2 rounded"
                    style={{ color: "#667085" }}
                    hidden={
                      SubSectionName ==
                      subSectionResp?.subSectionDetails[idx]?.subSectionName
                    }
                  >
                    {subSectionResp?.subSectionDetails[idx]?.subSectionName}
                  </b>
                </div>
                <br />
                <SectionNote section={subSectionResp?.subSectionDetails[idx]?.subsectionNote ?? ""} />
                {/* <span className="mx-4 text-muted"> {subSectionResp?.subSectionDetails[idx]?.subsectionNote}</span> */}
                {fields?.map((field, idx1) => (
                  <Box key={field?.id}>
                    {field?.subFields ? (
                      <FormControlWithSubFields
                        {...field}
                        isBold={field?.isBold}
                        userResponse={userResponse}
                        onResponseChange={onResponseChange}
                        IDX={idx}
                        SubSectionResp={subSectionResp}
                        VIEWMODE={VIEWMODE}
                        editAccess={subSectionResp?.subSectionDetails[idx]?.editAccess}
                        setValidate={setValidate}
                        languageId={languageId}
                        PQCLIENTID={PQCLIENTID}
                      />
                    ) : (
                      <>
                        <FormControl
                          isTrue={true}
                          fieldId={field?.id}
                          required={field?.required}
                          isBold={field?.isBold}
                          label={field?.text}
                          inputType={field?.inputType}
                          editAccess={subSectionResp?.subSectionDetails[idx]?.editAccess}
                          VIEWMODE={VIEWMODE}
                          multiple={field?.multiple}
                          items={field?.options}
                          value={userResponse[idx][field?.id] || ""}
                          //checked={userResponse[idx][field?.id] == 'true'}
                          checked={userResponse[idx][field?.id] == "true" || userResponse[idx][field?.id] == "True"}
                          handleChange={(value) =>
                            onResponseChange(field?.id, value, idx)
                          }
                          labelPositioning={
                            field?.labelPositioning || "horizontal"
                          }
                          fieldPositioning={
                            field?.fieldPositioning || "vertical"
                          }
                          width={field?.width}
                          disabled={field?.disabled || field?.qFormula}
                          color={field?.color}
                          heighlight={field?.heighlight}
                          Reference={field?.Reference}
                          //setValidate={(val)=>setValidate(field?.id, val, idx)}
                          setValidate={setValidate}
                          // setRequired={setRequired}
                          TableRefFieldValueDisplay={
                            field?.TableRefFieldValueDisplay
                          }
                          TableReference={field?.TableReference}
                          TableReferenceField={field?.TableReferenceField}
                          hasUnsavedChanges={hasUnsavedChanges}
                          buttonTypeReferenceValue={
                            field?.ButtonTypeReferenceValue
                          }
                          Pqid={PQID}
                          Triger={Triger}
                          reset={reset}
                          SAVE={SAVE}
                          languageId={languageId}
                          PQCLIENTID={PQCLIENTID}
                        />
                      </>
                    )}

                    {idx < unhiddenFields.length - 1 && <Divider />}
                  </Box>
                ))}
              </div>
            ))}
          </form>
          {SectionType == 33 ? (
            <>
              <a
                style={{ color: "blue", cursor: "pointer" }}
                onClick={GetAgreement}
              >
                Download PDF Of Agreement
              </a>
            </>
          ) : (
            ""
          )}
        </Box>
      )}
    </>
  );
}

QuestionnaireContext.propTypes = {};

QuestionnaireContext.defaultProps = {
  onResponseChange: () => { },
};